
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { MESSAGE_MAP } from '@/config/message';

export const useCamera = (handleScanSuccess) => {
  const store = useStore();
  const route = useRoute();

  const isQrScanOpened = ref(false);
  const constraints = ref({ facingMode: 'environment' });

  const isWebView = computed(() => store.getters['common/isWebView']);
  const useLinkageAppAndNecFlag = computed(() => store.getters['event/useLinkageAppAndNecFlag']);
  const usePosFlag = computed(() => store.getters['event/usePosFlag']);
  const nativeType = computed(() => store.getters['event/nativeType']);
  const directory = computed(() => route.params?.directory || route.query?.directory);
  const isPayUsePosFlag = computed(() => route.name === 'Pay' && usePosFlag.value);

  const onDetect = (content) => {
    const result = content.map((code) => code.rawValue);
    handleScanSuccess(result[0]);
  };
  const onCameraOn = () => {
    console.log('Successfully initialized! Ready for scanning now!');
  };
  const onCameraError = (error) => {
    if (route.name === '404' || (route.name === 'Home' && route.query?.notShowError)) return;
    store.dispatch('common/notClickOutside', true);
    store.dispatch('common/setModalTitle', 'カメラ機能について');
    store.dispatch('common/openErrorModal', true);
    store.dispatch('common/setErrors', [MESSAGE_MAP.cameraNotFound]);
    if (!isPayUsePosFlag.value) {
      store.dispatch('common/setModalBackToRoute', directory.value ? (route.name === 'TransferCpm' ? 'Mypage' : 'Home') : 'EventList');
    }
    console.log('error' + error?.message);
  };
  const customHandleScanSuccess = async (callback) => {
    callback();
  };
  const openedScanQr = () => {
    if (isWebView.value || (useLinkageAppAndNecFlag.value && nativeType.value)) {
      if (window.webkit) {
        // iOS
        window.webkit.messageHandlers.omise_message_launch_qrcode_scanner.postMessage('');
      } else if (window.android) {
        // Android
        window.android.launchQRcodeScanner();
      }
    } else {
      constraints.value.facingMode = 'environment';
      isQrScanOpened.value = true;
      store.commit('common/CLOSE_MODAL_QR_SCAN', false);
    }
  };

  return {
    isQrScanOpened,
    constraints,
    isWebView,
    useLinkageAppAndNecFlag,
    onDetect,
    onCameraOn,
    onCameraError,
    openedScanQr,
    customHandleScanSuccess
  };
};
